<template>
  <div>
    <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="container shape-container d-flex">
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <HotelDetailMiddle :hotelid="hotelid"></HotelDetailMiddle>
  </div>
</template>
<script>
import HotelDetailMiddle from "./components/HotelDetailMiddle";

export default {
  name: "Hoteldetail",
  components: {
    HotelDetailMiddle,
  },
  data() {
    return {
      hotelid: "",
    };
  },
  methods: {
    goback() {
      this.$router.push("/");
    },
    getHotelDetail() {},
  },
  created() {
    if (this.$route.query.hotelid) {
      this.hotelid = this.$route.query.hotelid;
    }
    
  },
};
</script>
<style scoped>
.position-relative {
  background-color: #f4f5f7;
  z-index: 1;
}
</style>